import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { CapabilitySuggestion } from '@indutrust/capability-model';
import { EnvironmentService } from '@indutrust/shared-env';
import { BaseApiClient } from '@indutrust/shared-model';
import type { Observable } from 'rxjs';

/**
 * API client for supplier capability-leaf suggestions —
 * `/capability_suggestions`.
 *
 * Approve / reject use the dedicated methods below.
 */
@Service()
export class CapabilitySuggestionApiClient extends BaseApiClient<CapabilitySuggestion> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template: Partial<CapabilitySuggestion> = {};

  /**
   * Approves a pending suggestion, creating the catalog leaf under the
   * chosen parent Technology (or an empty Technology parent umbrella).
   */
  approve(id: number): Observable<CapabilitySuggestion> {
    return this.http.patch<CapabilitySuggestion>(
      `${this.envService.getApiUrl()}/capability_suggestions/${id}/approve`,
      {}
    );
  }

  /**
   * Rejects a pending suggestion with an optional reason.
   */
  reject(id: number, reason = ''): Observable<CapabilitySuggestion> {
    return this.http.patch<CapabilitySuggestion>(
      `${this.envService.getApiUrl()}/capability_suggestions/${id}/reject`,
      { reason }
    );
  }

  get url(): string {
    return `${this.envService.getApiUrl()}/capability_suggestions`;
  }
}
